export default __webpack_public_path__ + "static/media/illustration-trees-1.f9ad4bb3.svg";